import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import {
  login,
  clearError,
  selectIstAngemeldet,
  selectAuthStatus,
  selectAuthError,
} from 'core/features/auth/authSlice';
import PageBackground from 'core/components/PageBackground';
import AuthCard from 'core/components/AuthCard';

/** Anmeldeseite (Benutzername + Passwort). */
export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const istAngemeldet = useSelector(selectIstAngemeldet);
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const zielPfad = location.state?.from?.pathname || '/';

  useEffect(() => {
    if (istAngemeldet) {
      navigate(zielPfad, { replace: true });
    }
  }, [istAngemeldet, navigate, zielPfad]);

  useEffect(() => () => dispatch(clearError()), [dispatch]);

  const absenden = (e) => {
    e.preventDefault();
    dispatch(login({ username: username.trim(), password }));
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <PageBackground name="overview" />
      <AuthCard
        titel="Anmelden"
        untertitel="Melde dich an, um auf dein Depot und deine Listen zuzugreifen."
      >
        <form onSubmit={absenden} className="flex flex-col gap-4">
          <AuthCard.Feld
            label="Benutzername"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoFocus
          />
          <AuthCard.Feld
            label="Passwort"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          {error && <AuthCard.Fehler text={error} />}
          <AuthCard.Button laeuft={status === 'loading'}>Anmelden</AuthCard.Button>
        </form>
        <p className="mt-6 text-center text-sm text-ink-muted">
          Noch kein Konto?{' '}
          <Link to="/register" className="font-medium text-ink underline hover:no-underline">
            Registrieren
          </Link>
        </p>
      </AuthCard>
    </div>
  );
}
